import { isNoEmptyArray, isNotEmptyString, isNullOrUndefined, isObject } from '@pineapplelab/util';
import "reflect-metadata";
export var Core;
(function (Core) {
    function setFieldValidator(target, fieldName, validator) {
        if (!isObject(target) || !isNotEmptyString(fieldName) || isNullOrUndefined(validator)) {
            return;
        }
        var validators = Reflect.getMetadata('validators:byField', target, fieldName) || [];
        validators.push(validator);
        Reflect.defineMetadata('validators:byField', validators, target, fieldName);
    }
    Core.setFieldValidator = setFieldValidator;
    function validate(object) {
        var response = { errors: [], fieldErrors: {}, fieldError: {}, fieldDecoratorError: {}, valid: true };
        validateByMetadata(object, response);
        response.valid = response.errors.length === 0;
        return response;
    }
    Core.validate = validate;
    function validateByMetadata(object, response) {
        if (!isObject(object)) {
            return;
        }
        var fields = Object.keys(object);
        fields.map(function (field) {
            var validators = Reflect.getMetadata('validators:byField', object, field);
            if (!isNoEmptyArray(validators)) {
                return;
            }
            var freePass = false;
            validators.filter(function (validator) { return validator.freePass; }).map(function (validator) {
                var valid = checkValidator(validator, response, object, field);
                if (valid) {
                    freePass = true;
                }
            });
            if (freePass) {
                return;
            }
            validators.map(function (validator) { return checkValidator(validator, response, object, field); });
        });
    }
    function checkValidator(validator, response, object, field) {
        var valid = validator.isValid(object, field);
        if (!valid && !validator.freePass) {
            var message = validator.message ? validator.message : "The field: '" + field + "' is not valid!";
            response.errors.push(message);
            if (isNullOrUndefined(response.fieldErrors[field])) {
                response.fieldErrors[field] = [];
            }
            if (isNullOrUndefined(response.fieldDecoratorError[field])) {
                response.fieldDecoratorError[field] = {};
            }
            response.fieldErrors[field].push(message);
            response.fieldError[field] = message;
            response.fieldDecoratorError[field][validator.name] = message;
        }
        return valid;
    }
})(Core || (Core = {}));
